"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_helmet_1 = require("react-helmet");
var use_celo_1 = require("../use-celo");
function IOSViewportFix() {
  var _ref = (0, use_celo_1.useCeloInternal)(),
    pendingActionCount = _ref.pendingActionCount,
    connectionCallback = _ref.connectionCallback;
  var isOpen = pendingActionCount > 0 || Boolean(connectionCallback);
  var tags = (0, react_1.useMemo)(function () {
    return react_device_detect_1.isMobile && isOpen && react_1.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1, maximum-scale=1"
    });
  }, [isOpen]);
  return react_1.default.createElement(react_helmet_1.Helmet, null, tags);
}
exports.default = IOSViewportFix;